// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.report-display-card-wrapper {
  border: var(--border-pri);
  padding: 0.8em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: var(--clr-white);
  box-shadow: 0px 0px 0px var(--clr-black);
  transition: scale 50ms linear, box-shadow 50ms linear;
  width: min(100%, 500px);
  margin: 0 auto;
  font-size: 1.2em;
  overflow: hidden;
}

div.report-display-card-top {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
}

span.report-display-card-date, span.report-display-card-total {
  font-size: 1.3em;
  text-wrap: nowrap;
  font-weight: 700;
  text-align: center;
}

div.report-display-card-breakdowns {
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  gap: 5px;
  width: 100%;
}

div.report-display-card-breakdown-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 0 0 3px 0;
  border: var(--border-pri);
  border-width: 0 0 1px 0;
  font-size: 0.7em;
}

div.report-display-card-breakdown-row:last-child {
  border: none;
}

.earning-color {
  color: var(--clr-earning);
}

.expense-color {
  color: var(--clr-expense);
}`, "",{"version":3,"sources":["webpack://./src/components/shared/reportDisplay/ReportDisplayCard.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;EACxC,qDAAqD;EACrD,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["div.report-display-card-wrapper {\n  border: var(--border-pri);\n  padding: 0.8em;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--clr-white);\n  box-shadow: 0px 0px 0px var(--clr-black);\n  transition: scale 50ms linear, box-shadow 50ms linear;\n  width: min(100%, 500px);\n  margin: 0 auto;\n  font-size: 1.2em;\n  overflow: hidden;\n}\n\ndiv.report-display-card-top {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  width: 100%;\n}\n\nspan.report-display-card-date, span.report-display-card-total {\n  font-size: 1.3em;\n  text-wrap: nowrap;\n  font-weight: 700;\n  text-align: center;\n}\n\ndiv.report-display-card-breakdowns {\n  padding: 10px 0;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n}\n\ndiv.report-display-card-breakdown-row {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  padding: 0 0 3px 0;\n  border: var(--border-pri);\n  border-width: 0 0 1px 0;\n  font-size: 0.7em;\n}\n\ndiv.report-display-card-breakdown-row:last-child {\n  border: none;\n}\n\n.earning-color {\n  color: var(--clr-earning);\n}\n\n.expense-color {\n  color: var(--clr-expense);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
